export var freeze = function (obj) { return Object.freeze(obj); };
